<template>
  <a-layout class='index animated fadeIn'>
    <a-card class="m-t-10" :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回 </a-button>
      <span class="ml15 fz-20">{{$route.query.type == 'add' ? '添加':'修改'}}微信图文</span>
    </a-card>
    <a-card :bordered='false'>
      <div class="s_flex_bian s_bor_cbed">
        <div class="width25">
          <p class="height-40 s_bf58 s_ptb0lr24 s_flex_ali s_font_b">图文列表</p>
          <transition-group appear tag="div">
            <div class="p-6 img_list" :class="active==index?'active':''" v-for="(item,index) in imgTextList" :key="item" draggable="true" @dragstart="dragstart(item)" @dragenter="dragenter(item)" @dragend="dragend(item)" @click="select(index)">
              <div class="s_po_re">
                <img v-if='item.file_url' class="img" :src="item.file_url.indexOf('http')!=-1?item.file_url:info.picdomain+'/'+item.file_url" alt="">
                <div class="img s_flex_center" v-else>
                  <div>
                    <PictureOutlined class="fz-40 s_c999" />
                    <p class="s_c999 text-ac">未上传</p>
                  </div>
                </div>
                <div class="s_po_ab_bl width100 height-35 p-l-15 p-r-15 s_flex_bian_c" style="background-color: rgba(0, 0, 0, .4);">
                  <p class="width80 s_omit s_cfff">{{item.title?item.title:"无"}}</p>
                  <DeleteFilled class="s_cfff fz-18" @click.stop='editList("del",index)' />
                </div>
              </div>
            </div>
          </transition-group>
          <div class="img_list" @click='editList("add")' v-if='imgTextList.length < 8'>
            <div class="img s_flex_center">
              <PlusOutlined class="fz-40 s_c999" />
            </div>
          </div>
        </div>
        <div class="width75 s_bl1 p-t-40 p-b-25">
          <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-item ref="title" label="标题" name="title">
              <a-input v-model:value="form.title" placeholder='请输入标题' @blur="setData" />
            </a-form-item>
            <a-form-item ref="author" label="作者" name="author" :rules="[{ required: true, message: '请输入作者' }]">
              <a-input v-model:value="form.author" placeholder='请输入作者' @blur="setData" />
            </a-form-item>
            <a-form-item ref="file_url" label="封面" name="file_url" help='建议尺寸：360像素 * 200像素' :rules="[{ required: true, message: '请选择图片' }]">
              <wxMaterial  :image="form.file_url" :max="1" v-on:handlechoose="(data)=>{form.file_url=data.imageUrl;form.media_id=data.data.media_id;setData()}" v-on:handledel="form.media_id='';form.file_url='';setData" />
            </a-form-item>
            <a-form-item ref="media_id" label="media_id" name="media_id" hidden>
              <a-input v-model:value="form.media_id" />
            </a-form-item>
            <a-form-item ref="digest" label="摘要" name="digest" :rules="[{ required: true, message: '请输入摘要' }]">
              <a-textarea v-model:value="form.digest" showCount :maxlength="120" :rows="4" placeholder='选填，该描述只在发送图文消息为单条时显示' @blur="setData" />
            </a-form-item>
            <a-form-item ref="content" label="正文" name="content" :rules="[{ required: true, message: '请输入正文' }]">
              <quill v-model:value="form.content" :content="JSON.parse(JSON.stringify(form.content))" v-on:change="setData" />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
              <a-button style="width:100px" type="primary" @click="onSubmit">
                保存
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import {
  DeleteFilled,
  PlusOutlined,
  PictureOutlined,LeftOutlined
} from "@ant-design/icons-vue";
import {
  ref,
  onMounted,
  inject,
  reactive,
  toRefs,
  onUpdated,
  watch,
} from "vue";
import { createwx_graphic } from "@/api/public_wx";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import { getWxGraphicMore, wxGraphicAdd, wxGraphicEdit } from "@/api/public_wx";
import store from "@/store";
let defForm = {
  name: "",
  file_url: "",
  content: "",
  img: "",
  media_id: "",
};
export default {
  components: { DeleteFilled, PlusOutlined, PictureOutlined,LeftOutlined },
  setup(props) {
    const form = ref({ ...defForm });
    const state = reactive({
      imgTextList: [{ title: "", file_url: "", media_id: "", content: "" }],
      labelCol: { span: 3 },
      wrapperCol: { span: 16 },
      oldNum: 0,
      newNum: 0,
      active: 0,
      info: store.state.user.info,
    });
    const $router = inject("$router");
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const ruleForm = ref();
    // 获取详情
    const getMore = async (id) => {
      let result = await getWxGraphicMore({ id })
        .then((res) => res.data)
        .catch((error) => error);
      state.imgTextList = result.data.list;
      form.value = state.imgTextList[0];
    };
    const editList = (type, index) => {
      if (type == "add") {
        state.imgTextList.push({
          title: "",
          file_url: "",
          media_id: "",
          content: "",
        });
      } else {
        if (state.imgTextList.length == 1) {
          $Modal.warning({
            title: "请至少保留一个图文",
            centered: true,
          });
          return false;
        }
       state.active=0
       select(0)
        state.imgTextList.splice(index, 1);
        state.active = state.imgTextList.length-1
        console.log(state.active)
      }
    };
    var select=(index)=>{
      state.active=index
      form.value = state.imgTextList[index]
    }
    // 记录初始信息
    const dragstart = (value) => {
      state.oldNum = value;
    };
    // 做最终操作
    const dragend = (value) => {
      if (state.oldNum != state.newNum) {
        let oldIndex = state.imgTextList.indexOf(state.oldNum);
        let newIndex = state.imgTextList.indexOf(state.newNum);
        state.active = newIndex;
        let newItems = [...state.imgTextList];
        // 删除老的节点
        newItems.splice(oldIndex, 1);
        // 在列表中目标位置增加新的节点
        newItems.splice(newIndex, 0, state.oldNum);
        // this.items一改变，transition-group就起了作用
        state.imgTextList = [...newItems];
      }
    };
    // 记录移动过程中信息
    const dragenter = (value) => {
      state.newNum = value;
    };
    // 保存信息
    const setData = () => {
      let index = state.active;
      state.imgTextList[index] = JSON.parse(JSON.stringify(form.value));
    };
    const router = inject("$router");
    // 提交
    const onSubmit = async () => {
      let result;
      if ($route.query.type == "edit") {
        result = await wxGraphicEdit({
          list_json: JSON.stringify(state.imgTextList),
          id:$route.query.id
        })
          .then((res) => res.data)
          .catch((error) => error);
      } else {
        result = await wxGraphicAdd({
          list_json: JSON.stringify(state.imgTextList),
        })
          .then((res) => res.data)
          .catch((error) => error);
      }
      if (iscode(result, true)) {
        $router.go(-1);
      }
    };
    onMounted(() => {
      if ($route.query.type == "edit") {
        getMore($route.query.id);
      }
    });
    return {
      ...toRefs(state),
      form,
      editList,
      dragstart,
      dragend,
      dragenter,
      setData,
      ruleForm,
      onSubmit,
      select
    };
  },
};
</script>
<style lang="less" >
.img_list .img {
  width: 100%;
  height: 200px;
}
.img_list {
  border: 1px solid #fff;
  border-bottom: 1px solid #83c8dd;
  cursor: pointer;
}
.active {
  border: 1px dashed #05486A;
}
</style>